import { put } from "redux-saga/effects";
import axios from "../../utils/axios";
import handle from "./handle";
import {
  GET_ALL_VISION_DATA,
  INIT_ALL_VISION_DATA,
  REQ_ALL_VISION_DATA,
  INIT_REQ_ALL_VISION_DATA,
} from "../../store/allVisionDataStore/actionType";
import { GLOBAL_STORE } from "../../store/globalStore/actionType";
import { GET_VISION_ITEM_DATA, REQ_VISION_ITEM_DATA } from "../../store/visionStore/actionType";
import config from "../../config";

const api = {
  //获取全部数据的数据
  getAllData: function * ({ params }) {
    if (params.page === 1) {
      yield put ({ type: GLOBAL_STORE, store: { globalLoading: true } });
    } else {
      yield put ({ type: GLOBAL_STORE, store: { loading: true } });
    }
    const res = yield axios ("/shop/vision/list", { ...params }, false, "GET");
    if (res && res.data) {
      const allData = {
        data: [...res.data.list],
        page: res.data["current_page"],
        onBottom: res.data["current_page"] >= res.data["total_page"]
      };
      if (params.page === 1) {//初始化
        yield put ({ type: INIT_ALL_VISION_DATA, allData });
        yield put ({ type: GLOBAL_STORE, store: { globalLoading: false } });
      } else {
        yield put ({ type: GET_ALL_VISION_DATA, allData });
        yield put ({ type: GLOBAL_STORE, store: { loading: false } });
      }
    }
  },
  //删除数据
  deleteData: function (params) {
    return axios (`/shop/vision/del?sid=${params.sid}`, { ...params }, false, "POST");
  },
  //获取数据
  getVisionItemData: function * ({ params }) {
    const { dict_id, sid, startDate, endDate } = params;
    yield put ({ type: GLOBAL_STORE, store: { globalLoading: true } });
    const res = yield axios ("/shop/vision/data", { start_date: startDate, end_date: endDate, dice_id: dict_id, sid });
    yield put ({ type: GLOBAL_STORE, store: { globalLoading: false } });
    if (res && res.data) {
      const info = handle.handleVisionItemData (res.data);
      yield put ({
        type: GET_VISION_ITEM_DATA,
        visionInfo: { info: { ...info }, trend: [...res.data.trend] }
      });
    }
  },
  saveVisionInfo: (params) => {
    const sid = params.sid ? params.sid : config.sid;
    return axios (`/shop/vision/eidt?sid=${sid}`, { ...params }, false, "POST");
  },
};

export { REQ_ALL_VISION_DATA, INIT_REQ_ALL_VISION_DATA, REQ_VISION_ITEM_DATA };
export default api;
